// API utility for correct backend URL in all environments
export const getApiBaseUrl = () => {
  // In production (popcrownofficial.com), use the members subdomain for API
  if (typeof window !== 'undefined' && window.location.hostname === 'popcrownofficial.com') {
    return 'https://members.popcrownofficial.com';
  }
  // In preview/development, use the injected backend URL
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  // Fallback to relative URL
  return '';
};

// Get the marketing site's own backend (for news, blog, etc.)
export const getMarketingSiteApiUrl = () => {
  // In production, use the main site's API
  if (typeof window !== 'undefined' && window.location.hostname === 'popcrownofficial.com') {
    return 'https://popcrownofficial.com';
  }
  // In preview/development, use the injected backend URL
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  return '';
};

// Legal Vault and Newsletter APIs use the members subdomain
export const getLegalVaultApiUrl = () => {
  return 'https://members.popcrownofficial.com';
};

export const apiFetch = async (endpoint, options = {}) => {
  // Legal Vault and Newsletter endpoints always use the members subdomain
  const isLegalVault = endpoint.startsWith('/api/legal-vault');
  const isNewsletter = endpoint.startsWith('/api/newsletter');
  const useMembersApi = isLegalVault || isNewsletter;
  
  // News endpoint uses the marketing site's own backend (has deduplication fix)
  const isNews = endpoint.startsWith('/api/news');
  
  let baseUrl;
  if (useMembersApi) {
    baseUrl = getLegalVaultApiUrl();
  } else if (isNews) {
    baseUrl = getMarketingSiteApiUrl();
  } else {
    baseUrl = getApiBaseUrl();
  }
  
  const url = `${baseUrl}${endpoint}`;
  return fetch(url, options);
};
